import TeamInviteModal from "./team-invite-modal";

export default TeamInviteModal;